import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {ContentItems as Component} from './ContentItems';

function mapStateToProps(state) {
  return {
    components: getComponents(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const ContentItems = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

const getCurrentSection = ({notebook}) => notebook.currentSection;

const getComponents = createSelector(
  [getCurrentSection],
  (currentSection) => currentSection.components
);
